import { TransactionFlow } from '../enums';
const BILLET_RECEIPT_FLOW_PATH = {
    [TransactionFlow.CASH_IN]: 'IN',
    [TransactionFlow.CASH_OUT]: 'OUT',
    [TransactionFlow.REVERSAL_IN]: 'REVERSAL_IN',
};
export function mapBilletReceiptFlow(transactionFlow) {
    return BILLET_RECEIPT_FLOW_PATH[transactionFlow];
}
